import { Routes } from '@angular/router';
import { MainLayoutComponent } from '@shared/presentation/components/main-layout/main-layout.component';
import { authGuard, publicGuard } from './modules/auth/presentation/guards/auth.guard';
import { permissionGuard } from './modules/auth/presentation/guards/permission.guard';
import { AppPermission } from './modules/auth/domain/enums/app-permission.enum';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [publicGuard],
    loadComponent: () =>
      import('./modules/auth/presentation/pages/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'forgot-password',
    canActivate: [publicGuard],
    loadComponent: () =>
      import('./modules/auth/presentation/pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'reset-password',
    canActivate: [publicGuard],
    loadComponent: () =>
      import('./modules/auth/presentation/pages/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'change-temporal-password',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./modules/auth/presentation/pages/change-temporal-password/change-temporal-password.component').then(
        (m) => m.ChangeTemporalPasswordComponent,
      ),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [permissionGuard],
        data: { permission: [AppPermission.UiDashboardComplete] },
        loadChildren: () =>
          import('./modules/dashboard/presentation/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES,
          ),
      },
      {
        path: 'clients',
        canActivate: [permissionGuard],
        data: { permission: [AppPermission.UiClients] },
        loadChildren: () =>
          import('./modules/clients/presentation/client.routes').then((m) => m.CLIENT_ROUTES),
      },
      {
        path: 'users',
        canActivate: [permissionGuard],
        data: { permission: [AppPermission.UiUsers] },
        loadChildren: () =>
          import('./modules/users/presentation/user.routes').then((m) => m.USER_ROUTES),
      },
      {
        path: 'orders',
        canActivate: [permissionGuard],
        data: { permission: [AppPermission.UiOrders] },
        loadChildren: () =>
          import('./modules/orders/presentation/order.routes').then((m) => m.ORDER_ROUTES),
      },
      {
        path: 'portfolios',
        canActivate: [permissionGuard],
        data: { permission: [AppPermission.UiPortfolios] },
        loadChildren: () =>
          import('./modules/portfolios/presentation/portfolio.routes').then(
            (m) => m.PORTFOLIO_ROUTES,
          ),
      },
      {
        path: 'quality-controls',
        canActivate: [permissionGuard],
        data: { permission: [AppPermission.UiQualityControl] },
        loadChildren: () =>
          import('./modules/quality-controls/presentation/quality-control.routes').then(
            (m) => m.QUALITY_CONTROL_ROUTES,
          ),
      },
      {
        path: 'connections',
        canActivate: [permissionGuard],
        data: { permission: [AppPermission.UiCommunications] },
        loadChildren: () =>
          import('./modules/connections/presentation/connections.routes').then(
            (m) => m.CONNECTIONS_ROUTES,
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./modules/profile/presentation/profile.routes').then(
            (m) => m.PROFILE_ROUTES,
          ),
      },
      {
        path: 'company-profile',
        canActivate: [permissionGuard],
        data: { permission: [AppPermission.UiCompanyProfile] },
        loadChildren: () =>
          import('./modules/company-profile/presentation/company-profile.routes').then(
            (m) => m.PROFILE_ROUTES,
          ),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: 'dashboard',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
